import style from "./scss/_app.scss";  

// import 'jquery';

// SCRIPT

import "./js/_libraries";

import "./js/_main";